import { ComponentPropsWithoutRef } from 'react';
import { Box } from '@mui/material';

import {
  EngagementChannelConfigFormValues,
  MultipleEnabledBanner,
  PushConfiguration,
  SmsConfiguration,
  useCanShowMultipleEnabledBanner,
} from '@occc/ui-notifications';
import { Divider } from '@occc-app/design-system';

import { MessageIntentConfigurator } from './message-intent-configurator';

type MessageEditFormProps = ComponentPropsWithoutRef<'form'> & {
  smsConfig: EngagementChannelConfigFormValues['smsConfig'];
  pushNotificationConfig: EngagementChannelConfigFormValues['pushNotificationConfig'];
};

export const MessageEditForm = (props: MessageEditFormProps) => {
  const { smsConfig, pushNotificationConfig, ...formProps } = props;
  const canShowMultipleEnabledBanner = useCanShowMultipleEnabledBanner();

  return (
    <form {...formProps}>
      <Box p={3}>
        <MessageIntentConfigurator />
      </Box>
      <Divider />
      <Box p={3}>
        <SmsConfiguration values={smsConfig} />
      </Box>
      <Divider />
      <Box p={3}>
        <PushConfiguration values={pushNotificationConfig} />
      </Box>
      {canShowMultipleEnabledBanner ? <MultipleEnabledBanner p={3} pt={0} /> : null}
    </form>
  );
};
